import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IstatConfiguration } from 'src/app/configuration/istat/istat-configuration';
import { Observable } from 'rxjs';
import {ListaIstatView} from "../../model/lista-istat-view";
import {AtecoConfiguration} from "../../configuration/ateco/ateco-configuration";

@Injectable({
  providedIn: 'root'
})
export class IstatService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  })
  constructor(public http: HttpClient) { }

  ricercaIstatByIdProfilo(id:any): Observable<any[]> {
    return this.http.get<any[]>(IstatConfiguration.ricercaIstatByIdProfilo + id, { headers: this.headers });
  }

  ricercaIstatByIdCompetenza(id:any): Observable<any[]> {
    return this.http.get<any[]>(IstatConfiguration.ricercaIstatByIdCompetenza + id, { headers: this.headers });
  }

  /*ricercaIstat(data: any, page: number, pageSize: number, searchType: number): Observable<any[]> {
    return this.http.post<any[]>(IstatConfiguration.ricercaIstat + page + "/" + pageSize + "/" + searchType, data, { headers: this.headers });
  }*/

  ricercaIstat(data: any, page: number, pageSize: number, searchType:number): Observable<ListaIstatView[]> {
    return this.http.post<ListaIstatView[]>(IstatConfiguration.ricercaIstat + page + "/" + pageSize + "/" + searchType, data, { headers: this.headers });
  }

  salvaIstatByIdProfilo(data:any,id:any) {
    return this.http.post<any[]>(IstatConfiguration.salvaIstatByIdProfilo + id, data, { headers: this.headers });
  }

  salvaIstatByIdCompetenza(data:any,id:any) {
    return this.http.post<any[]>(IstatConfiguration.salvaIstatByIdCompetenza + id, data, { headers: this.headers });
  }

  getCodiciIstatByIdProposta(id:any): Observable<any[]> {
    return this.http.get<any[]>(IstatConfiguration.getCodiciIstatByIdProposta + id, { headers: this.headers });
  }

  getCodiciIstatByIdCompetenza(id:any): Observable<any[]> {
    return this.http.get<any[]>(IstatConfiguration.getCodiciIstatByIdCompetenza + id, { headers: this.headers });
  }

  getElencoIstat(data: string): Observable<any[]> {
    return this.http.get<any[]>(IstatConfiguration.getElencoIstat + data, { headers: this.headers });
  }
}
